<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-06 15:29:22
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 10:49:24
-->
<template>
  <el-select
    v-bind="$attrs"
    v-model="contactId"
    clearable
    filterable
    :placeholder='placeholder'
    @change="change"
  >
    <el-option :label="item.nick_name" :value="item.open_id" v-for="item in optionList" :key="item.open_id"></el-option>
  </el-select>
</template>
<script>
import { partnerList } from '@/api/cooperationProgress';
import { drRoleType } from '@/utils/dataMap';
export default {
  name: 'DrPartnerSelect',
  props: {
    value: [String, Number, Array],
    placeholder: {
      type: String,
      default: '请选择达人招商'
    },
  },
  data() {
    return {
      contactId: this.value,
      optionList: [],
    }
  },
  watch: {
    value(val) {
      this.contactId = val;
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    change(val) {
      this.$emit('input', val);
    },
    async getList() {
      //达人商务
      const res = await partnerList({
        role_id: drRoleType.id,
        all_status:1
      })
      if(res.code === 0) {
          this.optionList = res.data
      }
    },
  }
}
</script>